// extracted by mini-css-extract-plugin
var _1 = "nIe1FnxWuR_GhUFK88ax";
export { _1 as "container" }
